import { store } from '../state/store';

/** Register the service worker in production builds and offer an in-app reload when an update is ready. */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  void import('virtual:pwa-register').then(({ registerSW }) => {
    const update = registerSW({
      immediate: true,
      onNeedRefresh() {
        store.toast('A new version of MemoNest is ready.', 'info', {
          label: 'Reload',
          run: () => void store.flush().then(() => update(true)),
        });
      },
      onOfflineReady() {
        store.toast('MemoNest is ready to work offline.', 'success');
      },
    });
  });
}
